import React from 'react'

import { IconBase } from '../IconBase'
import { IconProps } from '../types'

export const ArrowLeft: React.FC<IconProps> = (props) => (
  <IconBase {...props}>
    <path
      d="M19 12H5M5 12L12 19M5 12L12 5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
)
